/* Startsidan (release 2, design-2): svep med rullningslist för kategorikorten, pilar i det sociala flödets
   karusell och knappar som öppnar bilväljaren ("Välj din bil").
   Laddas av flera sektioner; körs bara en gång (data-dgd-js på <html>). */
(function () {
  'use strict';
  var html = document.documentElement;
  if (html.hasAttribute('data-dgd-js')) return;
  html.setAttribute('data-dgd-js', '');

  // Kategorikort på mobil: markören under korten följer svepet.
  function startaSvep(rot) {
    var rad = rot.querySelector('[data-dgd-svep-rad]');
    var markor = rot.querySelector('[data-dgd-markor]');
    if (!rad || !markor || rad.hasAttribute('data-dgd-klar')) return;
    rad.setAttribute('data-dgd-klar', '');
    function rita() {
      var max = rad.scrollWidth - rad.clientWidth;
      var andel = rad.scrollWidth > 0 ? rad.clientWidth / rad.scrollWidth : 1;
      markor.parentNode.style.visibility = max > 2 ? '' : 'hidden';
      if (max <= 2) return;
      var pos = rad.scrollLeft / max;
      markor.style.width = (andel * 100) + '%';
      markor.style.transform = 'translateX(' + (pos * (1 / andel - 1) * 100) + '%)';
    }
    rad.addEventListener('scroll', rita, { passive: true });
    window.addEventListener('resize', rita);
    rita();
  }

  // Socialt flöde: pilarna bläddrar ungefär en skärmbredd; föregående syns först när man har bläddrat.
  function startaKarusell(rot) {
    var rad = rot.querySelector('[data-dgd-karusell-rad]');
    var forra = rot.querySelector('[data-dgd-forra]');
    var nasta = rot.querySelector('[data-dgd-nasta]');
    if (!rad || rad.hasAttribute('data-dgd-klar')) return;
    rad.setAttribute('data-dgd-klar', '');
    function rita() {
      var start = rad.scrollLeft < 8;
      var slut = rad.scrollLeft + rad.clientWidth >= rad.scrollWidth - 8;
      if (forra) forra.hidden = start;
      if (nasta) nasta.hidden = slut;
    }
    function bladdra(riktning) {
      rad.scrollBy({ left: riktning * Math.max(rad.clientWidth * 0.75, 200), behavior: 'smooth' });
    }
    if (forra) forra.addEventListener('click', function () { bladdra(-1); });
    if (nasta) nasta.addEventListener('click', function () { bladdra(1); });
    rad.addEventListener('scroll', rita, { passive: true });
    window.addEventListener('resize', rita);
    rita();
  }

  // "Hitta delar till din bil" / "Välj bilmodell": till bilväljaren på startsidan, första lediga fältet får fokus.
  function oppnaValjare() {
    var hero = document.querySelector('.dg-bilval-hero');
    if (hero) {
      hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () {
        var falt = hero.querySelector('select:not([disabled])');
        var tomma = hero.querySelectorAll('select:not([disabled])');
        for (var i = 0; i < tomma.length; i++) { if (!tomma[i].value) { falt = tomma[i]; break; } }
        if (!falt) return;
        try { falt.focus({ preventScroll: true }); } catch (e) { falt.focus(); }
        falt.classList.remove('dg-design-markerad');
        void falt.offsetWidth;
        falt.classList.add('dg-design-markerad');
      }, 450);
      return true;
    }
    // Ingen hero på sidan: öppna raden under sidhuvudet.
    var knapp = document.querySelector('[data-dg-bilbar] [data-bb-oppna]:not([hidden])');
    if (knapp && knapp.offsetParent !== null) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(function () { knapp.click(); }, 300);
      return true;
    }
    return false;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-dgd-valjare]');
    if (!a) return;
    if (oppnaValjare()) e.preventDefault();
  });

  function starta() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-dgd-svep]'), startaSvep);
    Array.prototype.forEach.call(document.querySelectorAll('[data-dgd-karusell]'), startaKarusell);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starta);
  else starta();
  document.addEventListener('shopify:section:load', starta);
  window.addEventListener('load', function () {
    if (location.hash === '#dg-valj-bil') setTimeout(oppnaValjare, 300);
  });
})();
